import { API } from '@/services/api-core.service'

export const autoCompleteService = {
  async autoCompletePostalCode(postalCode, country) {
    return API.request(
      'GET',
      'api/autocomplete/postalcode',
      {
        postal_code: postalCode,
        language: navigator.language.split('-')[0],
        country_code: country
      },
      null,
      true
    )
  },
  async autoCompleteCity(city, country) {
    return API.request(
      'GET',
      'api/autocomplete/city',
      {
        city: city,
        language: navigator.language.split('-')[0],
        country_code: country
      },
      null,
      true
    )
  },
  async autoCompleteStreet(input, city, postalCode, distribution, country) {
    return API.request(
      'GET',
      'api/autocomplete/address',
      {
        street: input,
        postal_code: postalCode,
        locality: city,
        distribution: distribution,
        language: navigator.language.split('-')[0],
        country_code: country
      },
      null,
      true
    )
  },
  async autoCompleteEmail(input, name, firstname) {
    return API.request(
      'GET',
      'api/autocomplete/email',
      {
        email: input,
        name,
        firstname,
        language: navigator.language.split('-')[0]
      },
      null,
      true
    )
  },
  async validateAutocompletedValues(data) {
    return API.request('POST', 'api/autocomplete/validate', null, data, false, false)
  },
  async checkWebServiceAvailability(country = 'FR') {
    return API.request('POST', 'api/autocomplete/available', null, {'country': country}, true, true)
  }
}
